const lostStolenOrDamagedExpenseItemFields = [
  'infoEssentialMedicationItems',
  'infoJewelleryOrTraditionalWatchesItems',
  'infoLaptopsTabletsOrCamerasItems',
  'infoOtherUnspecifiedItems',
  'infoSpecifiedHighValueItems',
  'infoBankCardsOrTravelDocumentsItems',
  'infoCashItems',
];

export const hasAnyLostStolenOrDamagedExpenseItems = (form = {}) =>
  lostStolenOrDamagedExpenseItemFields.some((field) => Array.isArray(form[field]) && form[field].length > 0);

export const hasAnyValidLostStolenOrDamagedExpenseItems = (form = {}) => {
  const selectedBaggageEvents = form.whatHappenedToYourBaggageAndPersonalItems || [];
  const hasLostStolenOrDamagedSelected = Array.isArray(selectedBaggageEvents)
    && selectedBaggageEvents.includes('Lost, stolen or damaged items');

  return !hasLostStolenOrDamagedSelected || hasAnyLostStolenOrDamagedExpenseItems(form);
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.BaggageAndPersonalItems/validation.js